export default "__VITE_ASSET__ba94e022__"